import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
// import {unregister} from './registerServiceWorker';
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import * as UserHelpers from './helpers/userHelpers'
// import 'bootstrap/dist/css/bootstrap.min.css'

console.info("INDEX.JS*******************************************")

var config = {
  apiKey: 'AIzaSyC5pPDl2cnzv9UXDlKTbvjjj6Jgw3Fghyk',
  authDomain: 'blate-app.firebaseapp.com',
  databaseURL: 'https://blate-app.firebaseio.com',
  projectId: 'blate-app',
  storageBucket: 'gs://blate-app.appspot.com/',
  messagingSenderId: '897596285868',
}
window.firebaseApp = firebase.initializeApp(config)

var db
const settings = {}
firebase.firestore().settings(settings)

firebase
  .firestore()
  .enablePersistence()
  .then(function () {
    // Initialize Cloud Firestore through firebase
    db = firebase.firestore()

    window.firebaseDb = db
    window.firebaseApp.auth().onAuthStateChanged(function (user) {
      if (user) {
        console.info("USER: ", user)
        UserHelpers.ensureUserInDb(user)
      }
    })
    window.firebaseStorage = firebase.storage()
    window.firebase = firebase
    ReactDOM.render(<App db={db} />, document.getElementById('root'))
  })
  .catch(function (err) {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // TODO: NATE: give user a warning about limited functionality
      db = firebase.firestore()

      window.firebaseDb = db
      window.firebaseApp.auth().onAuthStateChanged(function (user) {
        if (user) {
          UserHelpers.ensureUserInDb(user)
        }
      })
      window.firebaseStorage = firebase.storage()
      window.firebase = firebase
      ReactDOM.render(<App db={db} />, document.getElementById('root'))
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
      db = firebase.firestore()

      window.firebaseDb = db
      window.firebaseApp.auth().onAuthStateChanged(function (user) {
        if (user) {
          UserHelpers.ensureUserInDb(user)
        }
      })
      window.firebaseStorage = firebase.storage()
      window.firebase = firebase
      ReactDOM.render(<App db={db} />, document.getElementById('root'))
    }
  })

registerServiceWorker()
// unregister()



// WEBPACK FOOTER //
// ./src/index.js